import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  number: {
    textAlign: 'right',
    marginRight: '12%'
  },
  empty: {
    fontStyle: 'italic',
    textAlign: 'right',
    marginRight: '12%'
  },
});
export default withStyles(styles)(({ column, classes }) => {
  return (<div className={column.countedValues ? classes.number : classes.empty}>
    {column.countedValues || ''}
  </div>)
});
